import { Accordion as StockAccordion, styled } from "@mui/material";

export const Accordion = styled(StockAccordion)`
  margin: 12px 0;
  padding: 20px 32px;
  background: #ffffff;
  border-radius: 14px !important;
  border: none !important;
  &:first-of-type {
    margin-top: 0;
  }
  &::before {
    content: "";
    display: none;
  }
`;
